import { __decorate } from "tslib";
import { css, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { sharedStyles } from '../../common/css/shared-styles';
import { USBrandCampaign } from '../../common/us-branding';
//import scrollama from "scrollama";
let CampaignSection = class CampaignSection extends USBrandCampaign {
    constructor() {
        super(...arguments);
        this.seen = false;
    }
    render() {
        return html `
    <div class="component--full">
      <div class="grid">
        <div class="left-col">
          <img src="./media/img/tech-image-it.jpg" alt="" class="banner ${this.seen ? `animate` : ``}" />
        </div>
        <div class="right-col">
          <div class="inner ${this.seen ? `animate` : ``}">
            <h2>Tecnologia e Innovazione guidano il cambiamento</h2>
            <p>Stiamo sviluppando e accelerando soluzioni tecnologiche per aiutare i clienti ad abbattere gli ostacoli alla crescita e a tenere il passo con la trasformazione radicale del nostro settore. Questo impegno per l'innovazione è stato pienamente dimostrato al nostro Innovation Forum 2025, un incontro ricco di ispirazione, discussioni e visioni sul futuro dell'Asset Management, dell'innovazione digitale e della costruzione del portafoglio. Rivivi l'evento guardando le registrazioni degli interventi e approfondisci gli argomenti di tuo interesse con le presentazioni dedicate.</p>
            <div>
              <a href="https://www.franklintempleton.it/approfondimenti/ft-academy#innovation-forum" class="cta" @click="${this.trackLink}" target="_blank">Scopri ora</a>
            </div>   
          </div>            
        </div>
      </div>
    </div>
    <slot></slot>`;
    }
};
CampaignSection.styles = [
    sharedStyles,
    css `
    :host {
        display: flex;
        max-width: 100%;
        margin: 0 auto;
        background: transparent;
        padding: 0;
        position: relative;
        z-index: 4;
        align-content: center;
        flex-wrap: wrap;        
        margin-top: 0rem;
    }

    @media (min-width: 768px) {
      :host {
        margin-top: 0rem;
        padding-top: 4rem !important;
      }
    }  

    @media (min-width: 1200px) {
      :host {
        margin-top: 0rem;
        padding-top: 6rem !important;
      }
    }    

    .grid {  
      margin: 2rem;
      width: calc(100% - 4rem);
      overflow: hidden;
    }

    @media (min-width: 768px) {
      .grid {  
        margin: 0;
        display: grid;
        grid-template-columns: 40% 55%;
        grid-template-rows: 1fr;
        gap: 5rem;
        grid-auto-flow: row;
      }      
    }


    
    .left-col {
      justify-self: start;
      align-self: start;
      grid-area: 1 / 1 / 2 / 2;
      width: 100%;
    }
    
    .right-col {
      justify-self: center; 
      align-self: center;       
      grid-area: 1 / 2 / 2 / 3;
      width: 100%;
    }
    
    h2, p {
      color: #fff;
    }

    a.cta {
      display: inline-block;
      background: #ffffff;
      padding: 0.6rem 1.25rem;
      border-radius: 45px;
      text-decoration: none;
      color: var(--ft-sky-blue);
    }    


    .asset-class {
      display: none;
    }

    @media (min-width: 768px) {

    .banner {
      transform: translateX(-50px);
      opacity: 0;
      max-width: 100%;
      border-radius: 5px 140px 5px 5px;
    }
    .banner.animate {
      animation: fade-in-left 2s cubic-bezier(0.390, 0.575, 0.565, 1.000) both;      
    }

    .inner {
      width: 100%;
      transform: translateX(50px);
      opacity: 0;      
    }

    .inner {
      width: 85%;
    }

    .inner.animate {
      animation: fade-in-right 2s cubic-bezier(0.390, 0.575, 0.565, 1.000) both;
    }

    .component--full {
      margin: 0rem 0 0 0rem;
    }        

    .logo--clarion-partners {
      margin-top: 1.6rem;
    }

  }

  @media (min-width: 1200px) {
    .inner {
      width: 70%;
    }    
  }

  .left-col img {
    width: 100%;

  }
  p, a {
    font-size: 1.1rem;
  }


  `
];
__decorate([
    property({ type: Boolean })
], CampaignSection.prototype, "seen", void 0);
CampaignSection = __decorate([
    customElement('campaign-section')
], CampaignSection);
export { CampaignSection };
//# sourceMappingURL=campaign-section.js.map